const uz = {
  // Navbar
  nav_features: "Imkoniyatlar",
  nav_howItWorks: "Qanday ishlaydi",
  nav_download: "Yuklab olish",
  nav_signIn: "Kirish",
  nav_downloadApp: "Ilovani yuklab olish",
  nav_partners: "Hamkorlarga",

  // Hero
  hero_badge: "Global to'lovlar · Jonli",
  hero_titleAccent: "Sizning ideal",
  hero_title2: "raqamli hamyoningiz",
  hero_subtitle: "150+ mamlakatda pulni bir zumda yuboring, oling va almashtiring. Chegarasiz, chaqmoq tezlikda, to'liq nazorat.",
  hero_downloadFree: "Bepul yuklab olish",
  hero_seeHow: "Qanday ishlaydi",
  hero_activeUsers: "Faol foydalanuvchilar",
  hero_services: "xizmatlar",
  hero_appRating: "App Store",
  hero_recentActivity: "So'nggi amallar",
  hero_topUp: "To'ldirish",
  hero_send: "Yuborish",
  hero_exchange: "Almashtirish",
  hero_history: "Tarix",
  hero_verifiedSecure: "Tekshirilgan va himoyalangan",
  hero_today: "bugun",
  hero_usdBalance: "USD Balansi",
  hero_eurBalance: "EUR Balansi",
  hero_btc: "BTC",
  hero_kztBalance: "KZT Balansi",
  hero_tx1: "Xizmatni to'ldirish",
  hero_tx2: "Johndan qabul qilindi",
  hero_tx3: "EUR → USD",
  hero_tx4: "Maksimdan qabul qilindi",
  hero_minAgo: "2 daqiqa oldin",
  hero_hrAgo: "1 soat oldin",
  hero_hrsAgo: "3 soat oldin",

  // Features
  feat_badge: "Nima uchun BroMoney",
  feat_title1: "Kerak bo'lgan hamma narsa,",
  feat_titleAccent: "ortiqchasi yo'q",
  feat_subtitle: "Tez, xavfsiz, qulay.",
  feat_instant_title: "Tezkor o'tkazmalar",
  feat_instant_desc: "5 daqiqadan 48 soatgacha — o'tkazma usuliga qarab.",
  feat_services_title: "Xizmatlar uchun to'lov",
  feat_services_desc: "Yuzlab xizmatlarni bir bosish bilan to'lang — kommunal, obunalar, internet va boshqalar.",
  feat_multicurrency_title: "Ko'p valyuta va kripto",
  feat_multicurrency_desc: "Turli blokcheyn tarmoqlarida kriptovalyutalar, USDT va fiat — hammasi bitta hamyonda.",
  feat_security_title: "Himoya",
  feat_security_desc: "Tranzaksiyalar va ma'lumotlar uchun ishonchli shifrlash. Mablag'laringiz 24/7 himoyada.",
  feat_app_title: "Mobil ilova",
  feat_app_desc: "iOS va Android uchun to'liq funksiyali nativ ilovalar.",
  feat_popular: "Mashhur",

  // Usage Flow
  flow_badge: "Qanday ishlaydi",
  flow_title1: "Tayyor bo'lish",
  flow_titleAccent: "3 oddiy qadamda",
  flow_subtitle: "Kechikishsiz. Pulni boshqarishning yaxshiroq usuli.",
  flow_step1_title: "Hisob yarating",
  flow_step1_desc: "2 daqiqada ro'yxatdan o'ting. Tezkor tasdiqlov — va hamyon tayyor.",
  flow_step2_title: "Pulni xavfsiz saqlang",
  flow_step2_desc: "BroMoney — ishonchli raqamli seyfingiz. Boshqa xizmatdan chiqarib to'ldiring va mablag'laringizni istalgan vaqtda nazorat qiling.",
  flow_step3_title: "Yuboring va to'lang",
  flow_step3_desc: "O'tkazing, valyuta konvertatsiya qiling va xizmatlarga to'lang — tez va oson.",
  flow_avgSetup: "O'rtacha ro'yxatga olish:",
  flow_2min: "2 daqiqa",
  flow_support: "Qo‘llab-quvvatlash soat",
  flow_supportTime: "11:00 dan 02:00 gacha (GMT+5)",
  flow_fundProtected: "Mablag' himoyalangan",

  // Personal/Business
  pb_badge: "Hamkorlar",
  pb_title1: "Biznes va hamkorlik",
  pb_contactBusiness: "Biznes bo'yicha bizga yozing",
  pb_reviews_title: "Foydalanuvchilarimiz nima deydi",
  pb_reviews_rating: "4,9 / 5 · 2 400+ sharh",
  review1_text: "Ajoyib hamyon — kripto va fiatda tez chiqaraman. Kurslar foydali, bunday shartlarni kamdan-kam uchratdim. Xalqaro o'tkazmalar bilan ishlovchilarga tavsiya qilaman.",
  review2_text: "Interfeys toza va intuitiv, darhol tushuniladi. Qo'llab-quvvatlash tez va aniq javob beradi. Har kuni ishlataman — juda qulay.",
  review3_text: "Xizmatlar uchun to'lov — zo'r. Pulni saqlash, kerak bo'lganda hisoblarga o'tkazish qulay. Xavfsiz va haqiqiy hayot qutqaruvchi.",

  // CTA
  cta_badge: "Bugun boshlang — Bu bepul",
  cta_title1: "Pulingiz,",
  cta_title2: "hamma joyda siz bilan",
  cta_subtitle: "BroMoney'ga tez, xavfsiz va chegarasiz to'lovlar uchun ishongan minglab foydalanuvchilarga qo'shiling.",
  cta_downloadOn: "Yuklab olish",
  cta_appStore: "App Store",
  cta_downloadApk: "Yuklab olish",
  cta_android: "Android",
  cta_getItOn: "Olish",
  cta_googlePlay: "Google Play",
  cta_rating: "App Store'da 4.9 reyting",
  cta_bankSecurity: "Bank darajasidagi xavfsizlik",
  cta_noHidden: "Yashirin to'lovlar yo'q",
  cta_account: "Shaxsiy kabinet",

  // Footer
  footer_desc: "Tezkor global to'lovlar, o'tkazmalar va almashtirish uchun sizning ideal raqamli hamyoningiz.",
  footer_goToWallet: "Hamyonga o'tish",
  footer_downloadAppStore: "App Store'dan yuklab olish",
  footer_downloadApk: "APK yuklab olish",
  footer_downloadGooglePlay: "APK yuklab olish (Google Play)",
  footer_copyright: "BroMoney. Barcha huquqlar himoyalangan.",
  footer_regulated: "BroMoney EU PSD2 direktivasi asosida tartibga solinadi. FCA tomonidan litsenziyalangan.",
  footer_privacy: "Maxfiylik siyosati",
  footer_terms: "Foydalanuvchi shartnomasi",

  // Language names
  lang_ru: "Русский",
  lang_kk: "Қазақша",
  lang_uz: "O'zbekcha",
  lang_en: "English",
};

export default uz;
